import React from 'react';
import PropTypes from 'prop-types';

import ActionBar from './actionbar';

import I18n from '@module/i18n';
import Button from '@component/form/element/button';

const UploadInProgressWarning = ({ cancelUpload, continueUpload }) => {
  return (
    <ActionBar text={I18n.t('notification.refresh_transfer_upload_lost')}>
      <Button
        type="actionbar-action"
        text={I18n.t('alert.confirm_refresh_transfer_upload_lost')}
        onClick={cancelUpload}
      />
      <Button
        type="actionbar-cancel"
        text={I18n.t('alert.cancel_refresh_transfer_upload_lost')}
        onClick={continueUpload}
      />
    </ActionBar>
  );
};

UploadInProgressWarning.propTypes = {
  continueUpload: PropTypes.func.isRequired,
  cancelUpload: PropTypes.func.isRequired,
};

export default UploadInProgressWarning;
